import React, {useState, useEffect} from "react"
import {Div, Tag, Text} from "atomize";
import styled from "styled-components";
import theme from "../../../Theme/Theme";
import {ReactComponent as PlayIcon} from "../../../Assets/Icons/play_button.svg";
import {baseUrl} from "../../../Constants/constants";
import VideoModal from "./../VideoModal";
import Skeleton from 'react-loading-skeleton';
import Fade from 'react-reveal/Fade';
import ReactGA from "react-ga";


const Wrapper = styled(Div)`

`;

const ImageWrapper = styled.a`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 20px rgba(0,0,0,.15);
  transition: box-shadow .2s ease-in-out;
  // &:before {
  //     // border: 1px solid ${theme.colors.primary};
  //     background: ${theme.colors.secondary};
  //     display: block;
  //     height: 100%;
  //     width: 100%;
  //     content: "";
  //     left: 5px;
  //     position: absolute;
  //     top: 5px;
  //     z-index: -1;
  // }
  img {
    width: 100%;
  }
  svg {
    position: absolute;
    transition: transform .2s ease-in-out;
  }
  &:hover,&:focus {
    box-shadow: 0 15px 25px rgba(0,0,0,.15);
    svg {
      transform: scale(1.25);
    }
  }
`;

const VideoTitle = styled(Text)`
  color: ${theme.colors.dark};	
  font-family: Inter;	
  font-size: 16px;	
  font-weight: 500;	
  line-height: 28px;
  margin: 1rem;
  text-align: center;
`;

function VideoCard(props) {
  const [open, setOpen] = useState(false);

  const updateHisorty = (title) => {
    const encodeTitle  = encodeURIComponent(title);
    props.history.push(`?video=${encodeTitle}`);
    ReactGA.pageview(window.location.pathname + window.location.search);
  };

  const clearHistory = () => {
    props.history.push("?");
  };

  useEffect( () => {
    if (props.loadVideo)  {
      setOpen(true);
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  },[props.loadVideo]);

  return (
    <Fade>
        <Wrapper>
          { props.mediaObj && props.video ?
            <>
              <VideoModal
                open={open}
                video={props.video}
                mediaObj={props.mediaObj}
                close={ () => {
                  setOpen(false);
                  props.urlParams && clearHistory();
                }}
              />
              <ImageWrapper
                onClick={() => {
                  setOpen(true);
                  props.urlParams && updateHisorty(props.video.title);
                }}
                tabIndex={0}
                aria-label={ 'video ' + props.video.title}
              >
                <PlayIcon/>
                <img
                  src={ baseUrl + props.mediaObj.thumbnail.uri.url}
                  alt={ 'video' + props.video.title}
                />
              </ImageWrapper>
              {
                props.showTitle &&
                <VideoTitle
                  as={'h4'}
                >{ props.video.title}</VideoTitle>
              }
            </>
            :
            <Skeleton
              width={'100%'}
              height={'250px'}
            />
          }
      </Wrapper>
    </Fade>
  )
}



export default VideoCard
